import DataStore from '../../stores/DataStore';
import { ModelDataUpdate } from '../../Events';
import { HousingValue } from '../../model/HousingValue';
import StringFormatter from '../../utility/StringFormatter';
import { defined, evaluate } from '../../utility/Control';
import Fetcher from '../../utility/Fetcher';

const UPPER_CASE_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export function init(tag: any): void {
  const onModelDataUpdate = () => {
    const housingValues = DataStore.getSurroundingHousingValues();
    if (housingValues) {
      map(DataStore.getSurroundingHousingValues(), tag);
    }
    tag.update();
  };
  tag.on('mount', () => {
    DataStore.addListener(ModelDataUpdate, onModelDataUpdate);
  });
  tag.on('unmount', () => {
    DataStore.removeListener(ModelDataUpdate, onModelDataUpdate);
  });
}

function map(housingValues: HousingValue[], tag: any): void {
  const housingValuePOs: HousingValuePresentationObject[] = [];
  let indexOfNextMapReferenceCharacter = 0;
  housingValues.forEach((housingValue: HousingValue) => {
    const housingValuePO: HousingValuePresentationObject = {};
    housingValuePO.address = housingValue.address;
    if (defined(housingValue.calculatedValue)) {
      housingValuePO.estimated = StringFormatter.formatMonetaryAmount(housingValue.calculatedValue.toString());
    }
    const cadastreHousingValueConveyance = housingValue.mostRecentFreeMarketConveyance;
    if (defined(cadastreHousingValueConveyance)) {
      housingValuePO.unitType = cadastreHousingValueConveyance.unitType;
      housingValuePO.dateRegistered = evaluate(cadastreHousingValueConveyance, 'dateRegistered.ddmmyyyy');
      if (defined(cadastreHousingValueConveyance.purchasePrice)) {
        housingValuePO.purchasePrice = StringFormatter.formatMonetaryAmount(
          cadastreHousingValueConveyance.purchasePrice.toString()
        );
      }
    }
    if (defined(housingValue.building)) {
      housingValuePO.unitType = housingValue.building.typeOfBuilding;
      housingValuePO.totalFloorSpace = housingValue.building.totalFloorSpace;
      const ddmmyyyy: string = evaluate(housingValue.building, 'usedDate.ddmmyyyy');
      if (defined(ddmmyyyy)) {
        housingValuePO.constructionYear = ddmmyyyy.split('-')[1];
      }
    }
    if (defined(housingValue.pricePerSquareMeter)) {
      housingValuePO.pricePerSquareMeter = StringFormatter.formatMonetaryAmount(
        housingValue.pricePerSquareMeter.toString()
      );
    }
    if (indexOfNextMapReferenceCharacter < UPPER_CASE_ALPHABET.length) {
      housingValuePO.mapReferenceCharacter = UPPER_CASE_ALPHABET.charAt(indexOfNextMapReferenceCharacter++);
    }
    if (defined(housingValue.cadastreKey)) {
      housingValuePO.cadastreKey = StringFormatter.formatCadastreKey(housingValue.cadastreKey);
      housingValuePO.fetch = () => {
        Fetcher.fetchModelData(housingValue.cadastreKey);
      };
    }
    housingValuePOs.push(housingValuePO);
  });
  tag.housingValues = housingValuePOs;
}

interface HousingValuePresentationObject {
  address?: string;
  estimated?: string;
  unitType?: string;
  dateRegistered?: string;
  purchasePrice?: string;
  totalFloorSpace?: number;
  constructionYear?: string;
  pricePerSquareMeter?: string;
  mapReferenceCharacter?: string;
  cadastreKey?: string;
  fetch?(): void;
}



/** WEBPACK FOOTER **
 ** ./src/components/surroundingHousingValuesDisplay/SurroundingHousingValuesDisplayMapper.ts
 **/